import { isNumber } from "lodash";
import { useState } from "react";
import { remoteEvent } from "../../../constants";
import { RemoteSocket } from "../../../controller";
import ExpressionDto from "../../../interfaces/expression/ExpressionDto";
import ExpressionSettingsDto from "../../../interfaces/expression/ExpressionSettingsDto";
import { EnumExpressions, EnumExpressionsText, mapExpressionPercentToColor } from "../../../utils/enum/EnumExpressions";
import { useEffectOnce } from "../../../utils/Utils";
import { mapExpressions } from "../../../utilsVue";

interface SlideStatusBarProps {
    countOfAttendees: number;
    expressionSettings: ExpressionSettingsDto;
    currentPage: number,
    currentSlide: number,
}

export default function SlidesStatusBar({ countOfAttendees, expressionSettings, currentPage, currentSlide }: SlideStatusBarProps) {
    const [expressionData, setExpressionData] = useState<ExpressionDto[]>([]);


    useEffectOnce(() => {
        RemoteSocket.on(remoteEvent.recv.EXPRESSION_UPDATE, handleExpressionData);

        return () => {
            RemoteSocket.off(remoteEvent.recv.EXPRESSION_UPDATE, handleExpressionData);
        };
    });

    const handleExpressionData = (data: any) => {
        if (currentPage != currentSlide) return;
        const arrayOfExp = mapExpressions(data);
        const parseData = arrayOfExp.map((item: any) => {
            return { id: item[0], ...item[1] };
        });
        setExpressionData(parseData);
    };


    const mapExpressionToIcon = (id: any) => {
        if (id === EnumExpressionsText.LOST) return {
            label: EnumExpressions[1],
            className: "lost",
            percentToNotify: expressionSettings.lost
        };
        else if (id === EnumExpressionsText.NOT_CLEAR) return {
            label: EnumExpressions[2],
            className: "pause",
            percentToNotify: expressionSettings.notClear
        };
        else if (id === EnumExpressionsText.GREAT) return {
            label: EnumExpressions[3],
            className: "great",
            percentToNotify: expressionSettings.great
        };
        else if (id === EnumExpressionsText.TOO_HARD) return {
            label: EnumExpressions[4],
            className: "rew",
            percentToNotify: expressionSettings.tooHard
        };
        else return { label: EnumExpressions[5], className: "ff", percentToNotify: expressionSettings.tooSimple }; // EnumExpressionsText.TOO_SIMPLE
    };


    return (
        <div style={{ color: "white", textAlign: "center" }}>
            {/* TODO expressions in row */}
            <div className="slide-stats-bar ">

                {expressionData.map(({ id, count, percentCount }) => {
                    const { label, className, percentToNotify } = mapExpressionToIcon(id);
                    let reactionColor = mapExpressionPercentToColor(id);
                    if (currentPage !== currentSlide) {
                        reactionColor = undefined;
                        count = 0;
                        percentCount = 0;
                    }

                    const progressClassName = () => {
                        if (count === 0 || !isNumber(count) || countOfAttendees === 0 || !expressionSettings.useFeedbackNotifications) return "progress";
                        const percentByAttendees = (count / countOfAttendees) * 100;

                        console.log(percentToNotify, percentByAttendees, count, countOfAttendees);

                        if (percentToNotify >= 0 && percentByAttendees >= percentToNotify) return "animated_progress";

                        return "progress";
                    }
                    return (
                        <div key={id} className={`slide-stats-bar__item slide-stats-bar__item--${className}`}>
                            <div className="slide-stats-bar__item__bar">

                                <div className={`slide-stats-bar__item__bar__${progressClassName()}`} style={{
                                    background: reactionColor,
                                    width: Number(percentCount) > 0 ? `${percentCount}%` : "0%",
                                    position: "relative",
                                }} />
                                <span style={{
                                    color: "white",
                                    fontWeight: 600,
                                    fontSize: 11,
                                    position: "absolute",
                                    marginTop: -14
                                }}>{count}</span>
                            </div>
                            <div className="slide-stats-bar__item__text">{label.toLowerCase()}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
